export interface ITabPanelProps {
	children?: React.ReactNode;
	selectedTabIndex: number;
	tabIndex: number;
	className: string;
}

const TabPanel: React.FunctionComponent<ITabPanelProps> = props => {
	return (
		<div
			className={props.className}
			tabIndex={props.tabIndex}
			role="tabpanel"
			hidden={props.selectedTabIndex !== props.tabIndex}
			style={{ overflow: 'auto' }}
		>
			{props.children}
		</div>
	);
};

export default TabPanel;
